function showOrderStatus(order_data) {
    var $ = jQuery.noConflict();
    // $('#tt-map canvas.mapboxgl-canvas').addClass('asdgasdg');
    // console.log('order_data', order_data);

    if (order_data.deliverymode === 'drivethru') {
        $('[data-order-type-name]').text('pick-up');
    } else if (order_data.deliverymode === 'dispatch') {
        $('[data-order-type-name]').text('delivery');
        $('span[order-status-order-received]').text(`Order in progress`);
        $('span[order-status-order-in-progress]').text(`Order made`);
        $('span[order-status-order-ready]').text(`Order delivered`);

    } else {
        $('[data-order-type-name]').text('time');
    }

    // Parse the date and time from the readytime string
    var currentTime = new Date();
    // console.log(currentTime, 'order_data.readytime', order_data.readytime);
    var timeOrderReady = new Date(order_data.readytime.substring(0, 4) + '-' +
        order_data.readytime.substring(4, 6) + '-' +
        order_data.readytime.substring(6, 8) + 'T' +
        order_data.readytime.substring(9, 14));

    // Add one hour to the order ready time
    var oneHourLater = new Date(timeOrderReady);
    oneHourLater.setHours(oneHourLater.getHours() + 1);

    // Check if the current time is one hour past the ready time
    if (currentTime >= oneHourLater) {
        // console.log('Order is 1 hour past ready');
        localStorage.setItem('orderPlacedMoreThanAnHourAgo', 'true');
    } else {
        localStorage.setItem('orderPlacedMoreThanAnHourAgo', 'false');
    }

    // Function to format the time into a 12-hour format (AM/PM)
    function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes + ' ' + ampm;
    }

    // Function to format the date in MM/DD/YYYY format
    function formatDate(date) {
        var month = date.getMonth() + 1; // Months are zero-based
        var day = date.getDate();
        var year = date.getFullYear();
        return month + '/' + (day < 10 ? '0' + day : day) + '/' + year;
    }

    // Check if the order ready time is today
    function isToday(date) {
        return date.getDate() === currentTime.getDate() &&
            date.getMonth() === currentTime.getMonth() &&
            date.getFullYear() === currentTime.getFullYear();
    }

    // Format the time
    var formatted_time = formatAMPM(timeOrderReady);

    // If the order is not for today, include the date
    if (!isToday(timeOrderReady)) {
        var formatted_date = formatDate(timeOrderReady);
        formatted_time = 'on ' + formatted_date + ' at ' + formatted_time;
    }


    // Format the time
    var formatted_time = formatAMPM(timeOrderReady);

    // If the order is not for today, include the date
    if (!isToday(timeOrderReady)) {
        var formatted_date = formatDate(timeOrderReady);
        formatted_time = 'on ' + formatted_date + ' at ' + formatted_time;
    }

    // Set the formatted time (and date if applicable) in the element
    $('[data-order-readytime]').text(formatted_time);


    //
    var progress = 0;
    var step = 0;

    var statusSwitch = order_data.status;

    if (order_data.deliverystatus) {
        statusSwitch = order_data.deliverystatus.deliveries[0].status;
    }
    $("[data-order-status]").text(statusSwitch);

    //order data status switch
    switch (statusSwitch) {
        case "New":
        case "Accepted":
        case "Transmitting":
        case "Scheduled": // Order Status Enum, Delivery Status Enum
        case "Pending Manual Fire": // Order Status Enum
        case "Pending": // Delivery Status Enum
            progress = 33.3;
            step = 1;
            break;
        case "Preparing":
        case "PickupInProgress": // Delivery Status Enum
            progress = 66.6;
            step = 2;
            break;
        case "Ready":
        case "In Progress": // Order Status Enum
        case "DeliveryInProgress": // Delivery Status Enum
            progress = 66.6;
            step = 2; 
            break;
        case "Delivered": // Delivery Status Enum
        case "Completed": // Order Status Enum, Delivery Status Enum
            progress = 100;
            step = 3;
            break;
        case "Canceled": // Order Status Enum, Delivery Status Enum
        case "Rejected":
            progress = 100;
            step = 4; 
            break;
        default:
            progress = 0;
            step = 0;
    }

    // Hide ready time if irrelivant
    if (["Delivered", "Completed", "Canceled", "Rejected"].includes(statusSwitch)) {
        $('.order-status-time').addClass('hide');
    } else {
        $('.order-status-time').removeClass('hide');
    }



    if (step === 1 || step === 0) {
        // console.log('#1');
        $(".order-tracker .progress-bar .step-1").addClass("active");
        $(".order-tracker .progress-bar div.step-1 span").addClass("bold-text");

        $(".order-tracker .progress-bar .progress-width").css("width", "calc(50% - 30px)");
        $(".homepage-order-status [data-store-direction-link]").addClass('desktop-align-left');
        $('h2[heading-stats-annoucement]').text("We’re getting started on your order!");
    } else if (step === 2) {
        // Add active class to the relevant steps
        $(".order-tracker .progress-bar .step-1").addClass("active");
        $(".order-tracker .progress-bar div.step-1 span").removeClass("bold-text");

        $(".order-tracker .progress-bar .step-2").addClass("active");
        $(".order-tracker .progress-bar div.step-2 span").addClass("bold-text");
        $(".homepage-order-status [data-store-direction-link]").removeClass('desktop-align-left');

        // console.log('#2');
        $('h2[heading-stats-annoucement]').text(`Your order will be ready by ${formatted_time}!`);
        $('.time-estimate').addClass('hide');
        // Get current time
        // console.log('Current Time:', currentTime);

        // Calculate the difference in milliseconds
        var timeDifference = timeOrderReady - currentTime;

        // Convert the difference from milliseconds to minutes
        var minutesLeft = Math.floor(timeDifference / 60000);
        // console.log('Time until order is ready (in minutes):', minutesLeft);
        //
        if (minutesLeft < 25) {
            // console.log('i small'); 
            percentLeft = ((((minutesLeft / 25) * 100) / 2) + 50);
            // console.log('percentLeft', percentLeft);
            $(".order-tracker .progress-bar .progress-width").css("width", `${percentLeft}%`);
        } else {
            $(".order-tracker .progress-bar .progress-width").css("width", "calc(50% + 30px)");
        }
    }
    else if (step === 3) {
        $(".order-tracker .progress-bar .step-1").addClass("active");
        $(".order-tracker .progress-bar .step-2").addClass("active");
        $(".order-tracker .progress-bar div.step-2 span").removeClass("bold-text");


        $(".order-tracker .progress-bar .step-3").addClass("active");
        $(".order-tracker .progress-bar div.step-3 span").addClass("bold-text");

        $('.time-estimate').addClass('hide');

        $(".order-tracker .progress-bar .progress-width").css("width", "calc(100% - 2px)");
        $(".homepage-order-status [data-store-direction-link]").removeClass('desktop-align-left');
        $(".homepage-order-status [data-store-direction-link]").addClass('desktop-align-right');

        // console.log('#3');
        if (order_data.deliverymode === 'drivethru') {
            $('h2[heading-stats-annoucement]').text(`Your order is ready for pickup!`);
        } else if (order_data.deliverymode === 'dispatch') {
            $('h2[heading-stats-annoucement]').text(`Your order is delivered!`);
        } else {
            $('h2[heading-stats-annoucement]').text(`Your order is ready for pickup!`);
        }
        $(".width-limiter span[data-thanks-instruction]").removeClass("hide");

    }
    else if (step === 4) {
        $('.order-tracker').parent().addClass('cancelled');
        $('.homepage-order-status').addClass('cancelled');
        $('.homepage-order-status button.start-new-order').removeClass('hide');

        // Add click event to navigate to the order page
        $('.homepage-order-status .button').on('click', function() {
            window.location.href = '/order/';
        }); 
    }
}
jQuery(document).ready(function ($) {
    // console.log('#1');
    const currentPath = window.location.pathname;
    // console.log('currentPath', currentPath);
    if (
        (localStorage.getItem('orderPlacedMoreThanAnHourAgo') === 'false') &&
        ((localStorage.getItem('charleys_customer_order') && $('body').hasClass('home')) || (localStorage.getItem('charleys_customer_order') && $('body').hasClass('page-id-18022')))
    ) {
        // console.log('#2');

        var session_order_data = JSON.parse(localStorage.getItem('charleys_customer_order'));
        var orderguid = session_order_data.id;

        $.ajax({
            type: 'POST',
            url: ajax_url,
            data: {
                action: 'olo_get_order',
                orderguid: orderguid
            },
            success: function (response) {
                order_data = JSON.parse(response);


                //display order tracker information
                showOrderStatus(order_data);
                if (localStorage.getItem('orderPlacedMoreThanAnHourAgo') === 'false') {
                    $.ajax({
                        type: 'POST',
                        url: ajax_url,
                        data: {
                            action: 'olo_get_restaurant',
                            restaurant_id: order_data.vendorid
                        },
                        success: function (response) {
                            var restaurant_data = JSON.parse(response);

                            // console.log('restaurant_data', restaurant_data);
                            //   envConsoleLog(restaurant_data);
                            var handoff_mode_label;
                            restaurant_data.labels.forEach(function (label) {
                                if (label.key == "handoffmode_" + order_data.deliverymode) {
                                    handoff_mode_label = label.value;
                                }
                            });
                            var thanks_instructions;
                            restaurant_data.labels.forEach(function (label) {
                                if (label.key == "manual_fire_label") {
                                    manual_fire_label = label.value;
                                }
                        
                                if (label.key == "handoffmode_" + order_data.deliverymode) {
                                    handoff_mode_label = label.value;
                                }
                        
                                if (
                                    label.key ==
                                    "thanks_" + order_data.deliverymode + "_instructions"
                                ) {
                                    thanks_instructions = label.value;
                                } else if (
                                    label.key ==
                                    "thanks_" + order_data.deliverymode + "pickup_instructions"
                                ) {
                                    thanks_instructions = label.value;
                                } else if (
                                    label.key ==
                                    "thanks_" + order_data.deliverymode + "instructions"
                                ) {
                                    thanks_instructions = label.value;
                                }
                            }); 
                            $(".width-limiter span[data-thanks-instruction]").text(thanks_instructions);

                            //Google address link
                            resturantNameWithReplacedSpaced = restaurant_data.name.replace(' ', '+');
                            let googleAddressLink = 'https://www.google.com/maps/dir/?api=1&destination=Charleys%2C+1+' + resturantNameWithReplacedSpaced + '+' + restaurant_data.zip;
                            // console.log(googleAddressLink);
                            $("[data-store-direction-link]").attr("href", googleAddressLink);

                            //
                            $('[data-store-location-address]').text(restaurant_data.streetaddress);
                            $('[data-store-location-state-zip]').text(restaurant_data.city + ', ' + restaurant_data.state + ' ' + restaurant_data.zip);

                            if ($('.homepage-order-status.order-tracker')) {
                                $('.homepage-order-status.order-tracker').removeClass('hide');
                            }
                        }
                    }); 
                }

            }
        });

    }
});